import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const AddNewCallerIdSchema = (): yup.AnyObjectSchema => {
  const { t } = useTranslation();

  const required = t('common.formErrorMessages.required');

  const schema = yup
    .object({
      phone: yup.string().required(required),
    })
    .required();

  return schema;
};

export default AddNewCallerIdSchema;
